import { render } from "./InquiriesList.vue?vue&type=template&id=2cc8df7a&scoped=true"
import script from "./InquiriesList.vue?vue&type=script&lang=js"
export * from "./InquiriesList.vue?vue&type=script&lang=js"

import "./InquiriesList.vue?vue&type=style&index=0&id=2cc8df7a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cc8df7a"]])

export default __exports__